import { ReactNode } from 'react';

import {
    CardStepChildren,
    CardStepElement,
    CardStepText,
    CardStepTitle,
} from './CardStep.styled';

interface CardStepProps {
    children?: ReactNode;
    className?: string;
    text: string;
    title: string;
}

export const CardStep = ({
    children,
    className,
    text,
    title,
}: CardStepProps) => {
    return (
        <CardStepElement className={className}>
            <CardStepTitle fontWeight="bold">{title}</CardStepTitle>
            <CardStepText>{text}</CardStepText>
            {children && <CardStepChildren>{children}</CardStepChildren>}
        </CardStepElement>
    );
};
